import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { NumberInput } from 'foundations-components/transitional/components/NumberInput';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { useGetErrorMessagesAndTranslations } from '../../hooks/useGetErrorMessagesAndTranslations';
import { setErrorMessages, getShowAllErrors } from '../../state/errorMessagesSlice';
import { jsx as _jsx } from "react/jsx-runtime";
const CustomFormFieldNumber = ({
  disabled,
  formField,
  onChange,
  value = null
}) => {
  const dispatch = useDispatch();
  const [hasBeenBlurred, setHasBeenBlurred] = useState(false);
  const showAllErrors = useSelector(getShowAllErrors);
  const isError = formField.required && (hasBeenBlurred || showAllErrors) && (value === null || value === undefined);
  const fieldLabel = formField.label;
  const errorKey = `empty${fieldLabel}`;
  const errorMessage = useGetErrorMessagesAndTranslations().get(errorKey);
  useEffect(() => {
    dispatch(setErrorMessages({
      [errorKey]: {
        isError,
        customFormFieldLabel: fieldLabel
      }
    }));
  }, [isError, dispatch, fieldLabel, errorKey]);
  return /*#__PURE__*/_jsx(FormControl, {
    help: formField.description || /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payments.contactInfo.numberInputHelper"
    }),
    label: fieldLabel,
    required: formField.required,
    error: isError,
    validationMessage: isError && errorMessage,
    paddingBlockStart: "100",
    children: /*#__PURE__*/_jsx(NumberInput, {
      "data-test-id": "custom-form-field-input-number",
      disabled: disabled,
      name: formField.name,
      onChange: onChange,
      use: "on-dark",
      value: value,
      onBlur: () => setHasBeenBlurred(true)
    })
  });
};
export default CustomFormFieldNumber;